import { render, staticRenderFns } from "./ListItemDetails.vue?vue&type=template&id=0c737e3c"
import script from "./ListItemDetails.vue?vue&type=script&lang=js"
export * from "./ListItemDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports